import { render, staticRenderFns } from "./GoodsOfferAccptItem.vue?vue&type=template&id=5da93796&"
import script from "./GoodsOfferAccptItem.vue?vue&type=script&lang=ts&"
export * from "./GoodsOfferAccptItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports